
import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './SearchBar.css';
import { useDispatch, useSelector } from 'react-redux';
import { GetItemBySearch } from '../../../../APIServices/SalesService/OrderService/OrderThunk';
import ItemData from '../../Orders/itemdata';
import { commonFilter } from '../../../../SharedFiles/Helper/utils';

const SearchBar = ({ itemGroupFlag, InProgress, cartItems, openModal,
  removeFromCart, setInProgress, setShowItemData, showItemData }) => {
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => setIsFocused(true);
  const [searchText, setSearchText] = useState('');

  const [filterData, setFilterData] = useState([]);
  const {
    ItemBySearch,
    ItemByGrp,
    error,
    loading } = useSelector((state) => state.order);



  useEffect(() => {

    if (itemGroupFlag !== 'true') {
      if (!error.ItemBySearchError) {
        if (ItemBySearch && !loading.ItemBySearch) {
          setFilterData(ItemBySearch);
        }
      } else if (error.ItemBySearchError) {
        setFilterData([]);
      }
    }
  }, [ItemBySearch, itemGroupFlag, error.ItemBySearchError]);
  const handleClear = () => {
    setIsFocused(false);
    setSearchText("");
    setShowItemData(false);
  };

  const handleSearchClick = () => {
    setShowItemData(true);
    if (itemGroupFlag !== 'true') {
      dispatch(GetItemBySearch({ searchText: "", page: 1 }));
    } else {
      setFilterData(ItemByGrp);
    }
  }
  const handleSearch = (e) => {
    if (loading.ItemBySearch) {
      return;
    }
    const searchText = e.target.value;
    if (itemGroupFlag !== 'true') {
      setInProgress({ ...InProgress, FetchSearchItem: true });
      dispatch(GetItemBySearch({ searchText: searchText, page: 1 }));
    } else if (itemGroupFlag === 'true'){
      const filter = commonFilter(ItemByGrp,"",searchText)
      setFilterData(filter);
    }
    
    setSearchText(searchText);

  };
  return (
    <div className='d-flex flex-column align-items-center'>
      <div className="searchDiv d-flex flex-row align-items-center">
        <input
          type="text"
          className="searchInput"
          placeholder="Search To Add"
          onFocus={handleFocus}
          value={searchText}
          onClick={handleSearchClick}
          onChange={(e) => {
            handleSearch(e);
          }} />
        <span
          className="searchIconSpan"
          onClick={showItemData ? handleClear : handleFocus}
        >
          {showItemData ? <CloseIcon /> : <SearchIcon />}
        </span>
      </div>
      <div className='searchItem'>
        {showItemData && 
          <div className="itemPageMain">
            <ItemData
              itemData={filterData}
              cartItems={cartItems}
              openModal={openModal}
              removeFromCart={removeFromCart} />
          </div>
        }
      </div>
    </div>
  )
}

export default SearchBar;